import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import PhoneIcon from '@material-ui/icons/Phone';
import { errorMessage } from '~/utils/Message';
import Backdrop from '~/components/BackdropComponent';
import CircularProgress from '@material-ui/core/CircularProgress';

import api from '~/services/api';

import { Container, Content } from './styles';

function Contact({ user }) {
  const [profile, setProfile] = useState(user);
  const [loading, setLoading] = useState(false);

  const { id, phone } = profile;

  const loadUser = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/users/${id}`);

      setProfile(data);
    } catch (error) {
      errorMessage(error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  return (
    <Container>
      <Content>
        <PhoneIcon />

        {!loading && (phone ? phone : 'Não informado')}
      </Content>

      <Backdrop open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
}

Contact.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    register: PropTypes.number,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
  }).isRequired,
};

export default Contact;
